import React from 'react';
import { Button, Modal } from 'antd';
import ManageDefaultValueModalContent from './ManageDefaultValueModalContent';
import { useSetBQRoutineDefaultValue } from 'mutation/acg/phase-1';
import { useGetBQRoutinesSyncStatus } from 'query/acg/phase-1';

type Props = {
  routineName: string,
};

export default function ManageDefaultValuesButton(props: Props) {
  const [visible, setVisible] = React.useState(false);
  const formRef = React.useRef(null);
  const { isLoading, mutateAsync } = useSetBQRoutineDefaultValue(
    props.routineName,
  );
  const { data, isLoading: syncStatusLoading } = useGetBQRoutinesSyncStatus();
  return (
    <>
      <Button
        disabled={data?.isSyncing}
        loading={syncStatusLoading || data?.isSyncing}
        onClick={() => setVisible(true)}
      >
        {data?.isSyncing ? 'Syncing In Progress...' : 'Manage Default Values'}
      </Button>
      <Modal
        okButtonProps={{
          loading: isLoading,
        }}
        title={`Manage Default Values of ${props.routineName}`}
        visible={visible}
        width={800}
        onCancel={() => setVisible(false)}
        onOk={async () => {
          const updatedValues = formRef.current.getUpdatedValues();
          await mutateAsync(updatedValues).catch(() => {});
          setVisible(false);
        }}
      >
        <ManageDefaultValueModalContent
          ref={formRef}
          routineName={props.routineName}
        />
      </Modal>
    </>
  );
}
